import { Injectable } from '@angular/core';
import { Asesor } from '../../models/agente/asesor.class';
import { Delegado } from '../../models/agente/delegado.class';
import { AdapterDetalleSelect } from '../../models/adapter/adapter-detalle-select';

@Injectable()
export class AdapterService {

  constructor() { }


  construirAdapterDetalleAgente(agenteItem: any): AdapterDetalleSelect[] {

    let adapter: AdapterDetalleSelect[] = [];

    if (agenteItem instanceof Asesor) {
      adapter = this.adapterCiudadAsesor(agenteItem);
    } else if (agenteItem instanceof Delegado) {
      adapter = this.adapterDelegacionesDelegado(agenteItem);
    }

    return adapter;
  }


  adapterCiudadAsesor(agenteItem: Asesor): AdapterDetalleSelect[] {
    const adapter: AdapterDetalleSelect[] = [];

    agenteItem.ciudades.forEach(element => {
      const itemAdapter = new AdapterDetalleSelect();
      itemAdapter.codigo = element.codigoAsesor;
      itemAdapter.descripcion = element.nombreCiudad;
      adapter.push(itemAdapter);
    });

    return adapter;
  }


  adapterDelegacionesDelegado(agenteItem: Delegado): AdapterDetalleSelect[] {
    const adapter: AdapterDetalleSelect[] = [];

    agenteItem.delegaciones.forEach(element => {
      const itemAdapter = new AdapterDetalleSelect();
      itemAdapter.codigo = element.codigo;
      itemAdapter.descripcion = element.nombre;
      adapter.push(itemAdapter);
    });

    return adapter;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/adapter/adapter.service.ts